import * as React from 'react';
import { Redirect, Route, RouteProps } from 'react-router-dom';
import { compose } from 'recompose';
import Routes from '../constants/Routes';
import { graphql, withApollo } from 'react-apollo';
import { GetUser } from '../queries/user';

type Props = {
  component: React.ComponentClass;
  user: any;
};

type PrivProps = Props & RouteProps;

const PrivateRoute: React.SFC<PrivProps> = ({ component, user, ...rest }) => {
  const renderFn = (Component?: React.ComponentClass) => (props: RouteProps) => {
    if (!Component) return null;
    if (user && user.loggedIn) return <Component {...props} />;
    return <Redirect to={{ pathname: Routes.login, state: { from: props.location } }} />;
  };
  return <Route {...rest} render={renderFn(component)} />;
};

const enhance = compose<Props, RouteProps>(
  withApollo,
  graphql(GetUser, {
    options: {
      fetchPolicy: 'cache-only',
    },
    props: (props: any) => ({
      user: props.data.user,
    }),
  }),
);

export default enhance(PrivateRoute);



// WEBPACK FOOTER //
// ./src/components/PrivateRoute.tsx